import { type VariantProps, cva } from 'class-variance-authority';
import { Link } from 'react-router';

import { Avatar, AvatarImage } from '~/components/ui/avatar.tsx';
import { cn } from '~/styles/extended-theme';

const colorVariant = cva('', {
  variants: {
    color: {
      light: 'text-primary-foreground',
      dark: 'text-foreground',
    },
  },
  defaultVariants: {
    color: 'dark',
  },
});

const sizeVariant = cva('', {
  variants: {
    size: {
      sm: 'size-8',
      md: 'size-10',
      lg: 'size-[72px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

type Props = {
  email: string;
  displayName: string;
  avatarUrl?: string | null;
} & VariantProps<typeof colorVariant> &
  VariantProps<typeof sizeVariant>;

export function UserAvatarProfileLink({ avatarUrl, email, displayName, color, size }: Props) {
  return (
    <Link to={`/account/profile`}>
      <div className="flex items-center gap-4">
        <Avatar className={sizeVariant({ size })}>
          <AvatarImage src={avatarUrl ?? '/img/person_96x96.png'} />
        </Avatar>
        <div className={cn('flex flex-col', colorVariant({ color }))}>
          <span className="text-subtitle2">{displayName}</span>
          <span className="text-body2">{email}</span>
        </div>
      </div>
    </Link>
  );
}
